import { observable, makeObservable } from "mobx";
import { MrbFilterParameters } from "mrb/core/filter";

class PremiumContentListFilter extends MrbFilterParameters {
    @observable contentType;
    initialValue = null;
    constructor(initialValue) {
        super();
        this.initialValue = initialValue;
        makeObservable(this);
        this.reset();
    }

    reset() {
        super.reset();
        this.contentType = this.initialValue;
    }
}

export default PremiumContentListFilter;
